import { FirstResetPasswordWidget, RouterWidget, SPI } from '@kunlun/dependencies';
import FirstResetPassword from './FirstResetPassword.vue'

@SPI.ClassFactory(RouterWidget.Token({ widget: 'FirstResetPassword' }))
export class CustomFirstResetPasswordWidget extends FirstResetPasswordWidget {
  public initialize(config) {
    super.initialize(config);
    this.setComponent(FirstResetPassword);
    return this;
  }
}
